import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useStyles = makeThemedStyles("PerspectiveCardList", (theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    columnGap: "32px",
    flexDirection: "row",
    flexWrap: "wrap",
  },
}));

const PerspectiveCardList = (props: React.PropsWithChildren<{}>) => {
  const classes = useStyles();
  return <div className={classes.root}>{props.children}</div>;
};

export default PerspectiveCardList;
